export const InvoiceFieldMap = {
   id: "invoiceId",
    documentOwner: "documentOwner",
    user: "customer",
    discountAmount: "discountAmount",
    description: "description",
    date: "invoiceDate",
    supplier: "supplier",
    category: "category",
    total: "totalAmount",
    documentReference: "documentReference",
    taxAmount: "taxAmount",
    submittedBy: "submittedBy"
} as const;

// // App (camelCase) ➜ API (PascalCase)
// export function mapAppToApi<T extends Record<string, any>>(data: T) {
//   return Object.fromEntries(
//     Object.entries(data)
//       .filter(([key]) => key in InvoiceFieldMap)
//       .map(([key, value]) => [
//         InvoiceFieldMap[key as keyof typeof InvoiceFieldMap],
//         value,
//       ])
//   );
// }


// // API (PascalCase) ➜ App (camelCase)
// export function mapApiToApp<T extends Record<string, any>>(data: T) {
//   return Object.fromEntries(
//     Object.entries(data)
//       .filter(([key]) => key in ApiToAppInvoiceFieldMap)
//       .map(([key, value]) => [
//         ApiToAppInvoiceFieldMap[
//           key as keyof typeof ApiToAppInvoiceFieldMap
//         ],
//         value,
//       ])
//   );
// }

